import { Utils } from '../Core';
import { listOfValuesApi as API } from '../Apis';
import { mocksService } from './ListOfValues.mock';
import dataFields from '../Types/ListOfValues.json';
import {
  IListOfValuesServiceRequestType,
  ValueItem,
  ValueListData,
} from '../Types/ListOfValues.types';
import { ListOfValuesApiResponse } from '../Apis/ListOfValuesApi';

const prepareCall = (params: IListOfValuesServiceRequestType) =>
  API.call.get(params);

const handleSucessFinalResponseFunction = (
  result: ListOfValuesApiResponse,
): ValueListData => {
  const items: ValueItem[] = result.valueByTypeList.map((it) => ({
    name: it.name,
    value: it.value,
    description: it.description,
  }));

  return { items };
};

export const { machine, Docs } = Utils.genericMachine({
  invokeApiFunction: prepareCall,
  definitionsAPI: API.definitions,
  mocksService,
  dataFields,
  handleResponse: {
    handleSucessFinalResponseFunction,
  },
});
